// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"08d19612","239":"e4180bbd","453":"c4682191","455":"9b933f06"}[chunkId] + ".chunk.js";
};